var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.className,attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M5 21v-6"}}),_c('path',{attrs:{"d":"M12 21V3"}}),_c('path',{attrs:{"d":"M19 21V9"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }